import React from 'react';

const SELECT_CLASSES =
  'rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500';

export function JobFilters({ search, onSearch, status, onStatus, sort, onSort, departments, department, onDepartment }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[200px]">
        <span className="absolute inset-y-0 left-3 flex items-center text-slate-400">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z" />
          </svg>
        </span>
        <input
          type="search"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Stelle suchen …"
          className={`${SELECT_CLASSES} w-full pl-9`}
        />
      </div>

      <select value={status} onChange={(e) => onStatus(e.target.value)} className={SELECT_CLASSES}>
        <option value="all">Alle Status</option>
        <option value="published">Veröffentlicht</option>
        <option value="draft">Entwurf</option>
      </select>

      <select
        value={department}
        onChange={(e) => onDepartment(e.target.value)}
        className={SELECT_CLASSES}
      >
        <option value="all">Alle Bereiche</option>
        {departments.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>

      <select value={sort} onChange={(e) => onSort(e.target.value)} className={SELECT_CLASSES}>
        <option value="recent">Zuletzt geändert</option>
        <option value="title">Titel A–Z</option>
        <option value="posted">Veröffentlichungsdatum</option>
      </select>
    </div>
  );
}
